import { render, staticRenderFns } from "./BulkCustomersOnboarding.vue?vue&type=template&id=356eb082"
import script from "./BulkCustomersOnboarding.vue?vue&type=script&lang=js"
export * from "./BulkCustomersOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports